<style scoped>
.modal-header {
    height: 6ex;
    padding: 0.5rem 1rem;
    align-items: center;
}
.modal-body {
    padding: 0;
}
.modal-content {
    border-bottom: 0;
}
.modal-content >>> .submissions-right-col,
.modal-content >>> .submissions-left-col {
    height: calc(97.5vh - 6ex);
    overflow: auto;
}
.modal-content >>> .testModeContainer .submissions-right-col,
.modal-content >>> .testModeContainer .submissions-left-col {
    height: calc(97.5vh - 6ex - 150px);
}
.modal-content {
    width: 97.5vw;
    height: 97.5vh;
}
</style>
<template>
    <div class="modal-content" ref="container">
        <div class="modal-header">
            <h2 class="modal-title">Review</h2>
            <button type="button" aria-label="Close" class="close icon icon-close" @click.prevent="close" />
        </div>
        <div class="modal-body">
            <PagePage :settings="settings" @close="close" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, defineAsyncComponent, computed, SetupContext, ref } from "vue";
import { dialogSetup, DialogProps } from "@/lib/dialogMixin.3";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
type Props = {
    form: {
        formName: string;
        formVersion: string;
        testMode: boolean;
        formId: string;
        tenant: string;
    };
} & DialogProps;
export default defineComponent({
    props: ["form", "triggerElement"],
    setup(props: Props, context: SetupContext) {
        const containerRef = ref<HTMLElement>(null!);
        const dialogMixin = dialogSetup(containerRef, props);
        const settings = computed(() => {
            return {
                inModal: true,
                adminReview: true,
                areaCode: props.form.tenant,
                formId: props.form.formId,
                formName: props.form.formName,
                formVersion: props.form.formVersion,
                testMode: props.form.testMode,
            };
        });

        const close = () => {
            dialogMixin.focusTrapSetEnabled(false);
            context.emit("close");
        };

        return {
            container: containerRef,
            settings,
            close,
        };
    },
    components: {
        PagePage: defineAsyncComponent({
            loadingComponent: LoadingPlaceholder,
            loader: () => import(/* webpackChunkName: "PagePage" */ "@/public/pages/Page.3.vue"),
        }),
    },
});
</script>
